import { type BillingPlanResponse } from "@/api/client";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

interface CancelSectionProps {
  plan: BillingPlanResponse;
  onCancel: () => void;
}

export default function CancelSection({ plan, onCancel }: CancelSectionProps) {
  const isCanceled = plan.subscription_status === "canceled";

  return (
    <section className={cn(theme.cards.base, "p-6 border-red-300 dark:border-red-500/50")}>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Cancel Subscription</h2>
      <p className={cn("text-sm mb-4", theme.text.error)}>
        Canceling will permanently delete all your data, including podcasts, episodes, transcripts, and chat history.
      </p>
      <button
        onClick={onCancel}
        disabled={isCanceled}
        className={cn(
          theme.buttons.destructive,
          "px-6 py-3 rounded-xl",
          isCanceled && "opacity-50 cursor-not-allowed",
        )}
      >
        Cancel Subscription
      </button>
      {isCanceled && (
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
          Your subscription has already been canceled.
        </p>
      )}
    </section>
  );
}

